var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.6 255.9",
    style: {
      enableBackground: "new 0 0 150.6 255.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#418c5a;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000052787419901465527940000013014205402158764725_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.9,127.7c-2-1.4-3.9-2.9-5.7-4.5c-29.5-29.4-59-58.9-88.5-88.4c-9.1-9.1-8.7-15.7,0-25.2 C19-3.9,26.4-2.4,38.1,9.5C73,44.9,108.3,79.8,143.4,115c9.5,9.5,9.5,16.2,0.2,25.6L35,249.1c-9.3,9.3-15.8,8.9-25.6-0.1 c-12.6-11.6-12-19.3,0-31c29-28.3,57.4-57.2,86.1-85.8C96.8,130.9,98.3,129.8,100.9,127.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.1209362b6083bca25568e437eaa5c63b.svg";
export { ForwardRef as ReactComponent };